import { api } from "api";

export const getTotalEmployeeStats = (onBegin, onSuccess, onError) => {
  return async (dispatch) => {
    onBegin();

    await api
      .get("/api/statistic/get-total-employee-statistic")
      .then((res) => {
        dispatch({
          type: "GET_TOTAL_EMPLOYEE_STATS_SUCCESS",
          payload: res.data,
        });

        onSuccess();
      })
      .catch((e) => {
        // if (api.isCancel(e)) {
        //   dispatch({
        //     type: "GET_TOTAL_EMPLOYEE_STATS_CANCELLED",
        //     payload: e,
        //   });
        //   onError("request_cancelled");
        // } else {
        dispatch({
          type: "GET_TOTAL_EMPLOYEE_STATS_ERROR",
          payload: e,
        });
        onError(e);
        // }
      });
  };
};

export const getTrainingCompletenessStats = (onBegin, onSuccess, onError) => {
  return async (dispatch) => {
    onBegin();
    await api
      .get("/api/statistic/get-training-completed-ratio-statistic")
      .then((res) => {
        dispatch({
          type: "GET_TRAINING_COMPLETENESS_STATS_SUCCESS",
          payload: res.data,
        });

        onSuccess();
      })
      .catch((e) => {
        dispatch({
          type: "GET_TRAINING_COMPLETENESS_STATS_ERROR",
          payload: e,
        });
        onError(e);
      });
  };
};

export const getEmployeeTurnoverStats = (onBegin, onSuccess, onError) => {
  return async (dispatch) => {
    onBegin();
    await api
      .get("/api/statistic/get-employee-turnover-statistic")
      .then((res) => {
        dispatch({
          type: "GET_EMPLOYEE_TURNOVER_STATS_SUCCESS",
          payload: res.data,
        });

        onSuccess(res);
      })
      .catch((e) => {
        dispatch({
          type: "GET_EMPLOYEE_TURNOVER_STATS_ERROR",
          payload: e,
        });
        onError(e);
      });
  };
};

export const getELearningCompletenessStats = (onBegin, onSuccess, onError) => {
  return async (dispatch) => {
    onBegin();
    await api
      .get("/api/statistic/get-elearning-completion-rates-statistic")
      .then((res) => {
        dispatch({
          type: "GET_ELEARNING_COMPLETENESS_STATS_SUCCESS",
          payload: res.data,
        });

        onSuccess();
      })
      .catch((e) => {
        dispatch({
          type: "GET_ELEARNING_COMPLETENESS_STATS_ERROR",
          payload: e,
        });
        onError(e);
      });
  };
};
